// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchbar {\n  width: 100% !important;\n}\n.searchbar input {\n  height: 38px;\n}\n.searchbar .cursor-pointer:hover {\n  color: #dc3545;\n}\n[dir] .searchbar .cursor-pointer:hover {\n  background-color: #f8f9fa;\n}\n.hidePagination div.con-vs-pagination {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
